import React from "react";

const Gitter = () => {
  return (
    <path d="M5,0 L8.1074848,0 L8.1074848,20.2685874 L5,20.2685874 L5,0 Z M23.8927633,4.91358952 L27,4.91358952 L27,20.2685874 L23.8927633,20.2685874 L23.8927633,4.91358952 Z M11.3390209,4.91358952 L14.4462576,4.91358952 L14.4462576,32 L11.3390209,32 L11.3390209,4.91358952 Z M17.5537424,4.91358952 L20.6612272,4.91358952 L20.6612272,32 L17.5537424,32 L17.5537424,4.91358952 Z" />
  );
};

export default Gitter;
